import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { enableChargingService } from '../../api/charging-service.ts';

export default function useEnableChargingService(): UseMutationResult<
  Awaited<ReturnType<typeof enableChargingService>>,
  Error,
  string
> {
  return useMutation({
    mutationFn: (serviceId: string) => enableChargingService(serviceId),
  });
}
